import AgencyBankInformation from './AgencyBankInformation/AgencyBankInformation';
import AgencyInformation from './AgencyInformation/AgencyInformation';
import Button from 'tailwind-components/Button/Button';
import OnboardingFormManagement from './OnboardingFormManagement/OnboardingFormManagement';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './AgencySettings.module.scss';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { SendEditAgencyInfoFormToAgent } from 'state/actions/actions';
import { getCompany } from 'helpers/getCompanyVariables';
import { areOnboardingInvitesDisabled } from 'helpers/viewing-rules';
import { isMobileWebView } from 'helpers/mobileWebView';

const company = getCompany();

const AgencySettings = ({
  agencyData,
  zohoData,
  setLocalLoader,
  getSpecificAgencyData,
  UpdateAgencyFormPreferences,
  SendAgencyFormEmail
}) => {
  const agencyInformation = agencyData.agencyInformation;
  const userAgencyData = zohoData?.agencyData;
  const invitesDisabled = areOnboardingInvitesDisabled(userAgencyData);
  const agencyDisplayName = agencyInformation?.name?._value?.trim() || '';
  const [focusEditBankingInfo, setFocusEditBankingInfo] = useState(false);

  const cancelTokenSource = axios.CancelToken.source();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      (async () => {
        await getSpecificAgencyData(setLocalLoader, id, cancelTokenSource);
        const shouldFocus = !!sessionStorage.getItem(
          'focus_agency_banking_edit'
        );
        setTimeout(() => {
          setFocusEditBankingInfo(shouldFocus);
          sessionStorage.removeItem('focus_agency_banking_edit');
        }, 1000);
      })();
    } else navigate('/agencies');

    return () => {
      cancelTokenSource.cancel('API Call Canceled');
    };
  }, []);

  return (
    <div className={styles.agencySettings}>
      {!(isMobileWebView() && company === 'oneill') && (
        <div className='mb-4'>
          <Button
            variant='secondary'
            size='xsmall'
            icon={<ArrowLeft size={24} />}
            text='Go to Agency Dashboard'
            onClick={() =>
              navigate(
                company === 'oneill'
                  ? `/agency/dashboard/${id}`
                  : `/agencies/${id}`
              )
            }
          />
        </div>
      )}

      <div className='mb-4 flex flex-col gap-4 rounded-xl border-b border-grey-lighter bg-white p-5 sm:p-6'>
        <header className='flex flex-col gap-3'>
          <h2 className='m-0 text-2xl font-semibold! leading-none'>
            Agency Settings
            {!invitesDisabled && ' & Invites'}
          </h2>
          {agencyDisplayName && (
            <p className='m-0 mt-1 text-sm leading-relaxed text-grey md:text-base'>
              <span className='font-normal'>
                Managing settings {invitesDisabled ? '' : ' and invites'} for:{' '}
              </span>
              <span className='font-medium text-black'>
                {agencyDisplayName}
              </span>
            </p>
          )}
        </header>
      </div>

      <div data-tour='settings-onboarding' className={styles.settingsSection}>
        <OnboardingFormManagement
          UpdateAgencyFormPreferences={UpdateAgencyFormPreferences}
          SendAgencyFormEmail={SendAgencyFormEmail}
        />
      </div>
      <div data-tour='settings-banking' className={styles.settingsSection}>
        <AgencyBankInformation
          agencyInformation={agencyInformation}
          SendEditAgencyInfoFormToAgent={SendEditAgencyInfoFormToAgent}
          focusEditBankingInfo={focusEditBankingInfo}
        />
      </div>
      {company === 'sunshine' && (
        <AgencyInformation agencyInformation={agencyInformation} />
      )}
    </div>
  );
};
AgencySettings.propTypes = {
  agencyData: PropTypes.object,
  zohoData: PropTypes.object,
  setLocalLoader: PropTypes.func,
  getSpecificAgencyData: PropTypes.func,
  UpdateAgencyFormPreferences: PropTypes.func,
  SendAgencyFormEmail: PropTypes.func
};

export default AgencySettings;
